import React, { useRef, useState } from "react";
import classes from "./Hospitals.module.css";
import { LoadingOutlined } from "@ant-design/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import NavbarSliderLeftIcon from "../../../UI/NavbarSliderLeftIcon";
import NavbarSliderRightIcon from "../../../UI/NavbarSliderRightIcon";
import { Link } from "react-router-dom";
import { Col, Row } from "antd";

const Hospitals = ({
  branches,
  branchesLoading,
  setShowHospitalsDropdown,
  settings,
}) => {
  const [branchImages, setBranchImages] = useState(
    branches?.length > 0 ? branches[0].images : []
  );
  const [branchDetails, setBranchDetails] = useState(
    branches?.length > 0 ? branches[0].name : undefined
  );
  console.log("branches 0000", branches);
  const swiperRef = useRef(null);
  return (
    <div className={classes.outerContainer}>
      {branchesLoading && (
        <div className={classes.loadingDiv}>
          <LoadingOutlined className={classes.loadingIcon} />
        </div>
      )}
      {!branchesLoading && (
        <div className={classes.menuContainer}>
          <div className={classes.leftSection}>
            <h5 className={classes.leftTitle}>
              Accessible Care Across Locations
            </h5>
            <div className={classes.divideLine}></div>
            <div className={classes.leftContainer}>
              <Row gutter={16} style={{ width: "100%" }}>
                {branches?.map((branch) => (
                  <Col span={8}>
                    <Link
                      to={`/branch/${branch.slug}`}
                      onClick={() => setShowHospitalsDropdown(false)}
                    >
                      <h4 className={classes.branchName}>{branch.name}</h4>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          <div className={classes.rightSection}>
            <h1>Instant Access</h1>
            <a href={`tel:${settings?.contactNumber}`}>
              <div className={classes.dataDiv}>
                <img src="/img/icons/helpline.svg" alt="logo" />
                <div className={classes.details}>
                  <h4>Health Help Line</h4>
                  <h4>{settings?.contactNumber}</h4>
                </div>
              </div>
            </a>
            <a href={`tel:${settings?.whatsappNumber}`}>
              <div className={classes.dataDiv}>
                <img src="/img/icons/nav-whatsapp.svg" alt="logo" />
                <div className={classes.details}>
                  <h4>Whatsapp</h4>
                  <h4>{settings?.whatsappNumber}</h4>
                </div>
              </div>
            </a>
            <a href={`mailto:${settings?.email}`}>
              <div className={classes.dataDiv}>
                <img src="/img/icons/mail.svg" alt="logo" />
                <div className={classes.details}>
                  <h4>Email</h4>
                  <h4>{settings?.email}</h4>
                </div>
              </div>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hospitals;
